import { FC, useState, useEffect } from "react";
import Icons from "src/common/icons";
import { IVanFetch } from "src/models/IVan";


interface IProps {
    data: string[];
    vans: { [key: string]: IVanFetch[] };
    renderItem: (item: IVanFetch) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
    show: number;
    setShow: (show: number) => void;
    filterLocation: string;
}

const InfiniteScrollNearVan: FC<IProps> = ({ data, vans, renderItem, loading, setLoading, show, setShow, filterLocation }) => {

    const dataWithoutFIlter = data.filter(location => location !== filterLocation);
    const [list, setList] = useState(dataWithoutFIlter.slice(0, 2));

    useEffect(() => {
        if (!loading) return;
        if (show >= dataWithoutFIlter.length) return setLoading(false);
        setTimeout(() => {
            setList(list.concat(dataWithoutFIlter.slice(show, show + 2)));
            setShow(show + 2);
            setLoading(false);
        }, 1000);
    }, [loading]);

    return (
        <>
            {list.map(location => (
                <>
                    {/* <div className="vans__locations-nearby">
                        <div>You can book a delivery or pickup from </div>
                        <div className="vans__locations-nearby__location-from">
                            <span className="vans__locations-nearby__location-from__img">
                                <Icons.Label />
                            </span>
                            <b>{location}</b>
                        </div>
                    </div> */}
                    {
                        vans[location].map(renderItem)
                    }
                </>
            ))}
        </>
    );
};
export default InfiniteScrollNearVan;